import { useCallback, useContext, useEffect } from "react"
import ModelElements from "../ModelElements"
import type { ProductModelProps } from "../ModelViewerProduct"
import ProductTextureContext from "../_contexts/ProductTextureContext"
import useGLB from "../_hooks/useGLB"
import { FindMaterial } from "../../Common/Utils/ThreeTools"
import { Vector2 } from "three"

const normalScale = new Vector2(0.5, -0.5)

export default function AluminumPrint(props: ProductModelProps) {
    /* Gotta load all the models this way because dynamic paths in URL() aren't picked up by webpack */
    const getUrl = useCallback(() => {
        return {
            '11x14': new URL('@resources/3d-models/glb/aluminum-print-11x14.glb', import.meta.url),
            '14x11': new URL('@resources/3d-models/glb/aluminum-print-14x11.glb', import.meta.url),
            '12x12': new URL('@resources/3d-models/glb/aluminum-print-12x12.glb', import.meta.url),
            '12x16': new URL('@resources/3d-models/glb/aluminum-print-12x16.glb', import.meta.url),
            '16x12': new URL('@resources/3d-models/glb/aluminum-print-16x12.glb', import.meta.url),
            '12x18': new URL('@resources/3d-models/glb/aluminum-print-12x18.glb', import.meta.url),
            '18x12': new URL('@resources/3d-models/glb/aluminum-print-18x12.glb', import.meta.url),
            '16x16': new URL('@resources/3d-models/glb/aluminum-print-16x16.glb', import.meta.url),
        }[props.variant]
    }, [props.variant])

    const model = useGLB(getUrl() ?? new URL('@resources/3d-models/glb/aluminum-print-11x14.glb', import.meta.url))
    const elements = model.scene.children
    const [productTexture] = useContext(ProductTextureContext)

    // Adjust normals
    useEffect(() => {
        const metalMaterial = FindMaterial('metal', elements)
        if (metalMaterial) metalMaterial.normalScale = normalScale

        const designMaterial = FindMaterial('design', elements)
        if (designMaterial) designMaterial.normalScale = normalScale
    }, [elements])

    // Apply lab texture
    useEffect(() => {
        const designMaterial = FindMaterial('design', elements)
        if (designMaterial) {
            designMaterial.map = productTexture
            designMaterial.map.flipY = false
            designMaterial.map.needsUpdate = true
        }
    }, [productTexture, elements])
    
    return <ModelElements scene={model.scene} forceUpdate={props.variant}/>
}
